<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
              <div class="card-header align-items-center border-bottom-dark px-0">
                <div class="card-title mb-0">
                  <h3 class="card-label mb-0 font-weight-bold text-body">Coupon Leads</h3>
                </div>
                <div>
                  <router-link to="/admin/popup" class="btn btn-light btn-sm mr-2">Offer settings</router-link>
                  <button type="button" class="btn btn-primary btn-sm" @click="exportCsv()">Export to Excel</button>
                </div>
              </div>
            </div>

            <!-- Stats -->
            <div class="row">
              <div class="col-6 col-lg" v-for="s in statCards" :key="s.label">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body py-4">
                    <div class="text-muted small">{{ s.label }}</div>
                    <div class="font-weight-bold" style="font-size:24px;">{{ s.value }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-custom gutter-b bg-white border-0">
              <div class="card-body">
                <div class="dataTables_wrapper no-footer">
                  <div class="d-flex flex-wrap align-items-center justify-content-between mb-3" style="gap:12px;">
                    <div class="btn-group">
                      <button v-for="f in filters" :key="f.value" type="button"
                        class="btn btn-sm" :class="status === f.value ? 'btn-primary' : 'btn-light'"
                        @click="status = f.value; fetchLeads()">{{ f.label }}</button>
                    </div>
                    <div class="dataTables_filter">
                      <label>Search:
                        <input type="text" v-model="search" @keyup="debouncedFetch()" placeholder="Email, phone or code" />
                      </label>
                    </div>
                  </div>

                  <div style="overflow-x:auto;">
                    <table class="display dataTable no-footer" style="width:100%">
                      <thead class="text-body">
                        <tr>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Coupon</th>
                          <th>Status</th>
                          <th>Expires</th>
                          <th>Order</th>
                          <th>In cart</th>
                          <th>Requested</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="leads.length === 0">
                          <td colspan="9" class="text-center">No leads yet.</td>
                        </tr>
                        <tr v-for="l in leads" :key="l.id">
                          <td>{{ l.email }}</td>
                          <td>{{ l.phone || '—' }}</td>
                          <td>
                            <strong style="letter-spacing:1px;">{{ l.code }}</strong>
                            <div class="small text-muted">{{ l.type === 'fixed' ? '$' + l.amount : l.amount + '%' }} off<span v-if="l.exclude_sale_items">, not on sale items</span></div>
                          </td>
                          <td>
                            <span class="badge" :class="badge(l.state)">{{ l.state }}</span>
                          </td>
                          <td>{{ l.expiry_date }}</td>
                          <td>
                            <router-link v-if="l.order_id" :to="'/admin/order/' + l.order_id">#{{ l.order_id }}</router-link>
                            <div v-if="l.order_id" class="small text-muted">${{ money(l.order_price) }}</div>
                            <span v-else class="text-muted">—</span>
                          </td>
                          <td>{{ l.cart_count > 0 ? l.cart_count + ' item(s)' : '—' }}</td>
                          <td>{{ (l.created_at || '').substring(0, 10) }}</td>
                          <td class="text-nowrap">
                            <template v-if="l.state !== 'used'">
                              <button type="button" class="btn btn-light btn-sm" @click="extend(l)">+7 days</button>
                              <button v-if="l.state === 'unused'" type="button" class="btn btn-light btn-sm text-danger" @click="disable(l)">Disable</button>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="dataTables_paginate paging_simple_numbers">
                    <ul class="pagination">
                      <li class="paginate_button page-item" :class="{ disabled: !meta.prev_page_url }">
                        <a class="page-link" href="#" @click.prevent="fetchLeads(meta.prev_page_url)">Previous</a>
                      </li>
                      <li class="paginate_button page-item active">
                        <a class="page-link" href="#">{{ meta.current_page }} / {{ meta.last_page }}</a>
                      </li>
                      <li class="paginate_button page-item" :class="{ disabled: !meta.next_page_url }">
                        <a class="page-link" href="#" @click.prevent="fetchLeads(meta.next_page_url)">Next</a>
                      </li>
                    </ul>
                    <div class="mt-2 text-muted">Total: {{ meta.total }} leads</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leads: [],
      stats: {},
      meta: {},
      status: 'all',
      search: '',
      token: {},
      timer: null,
      filters: [
        { value: 'all', label: 'All' },
        { value: 'unused', label: 'Not used yet' },
        { value: 'used', label: 'Used' },
        { value: 'expired', label: 'Expired' },
      ],
    };
  },
  computed: {
    statCards() {
      const s = this.stats;
      const rate = s.leads ? Math.round((s.used / s.leads) * 100) : 0;
      return [
        { label: 'Leads', value: s.leads || 0 },
        { label: 'Last 7 days', value: s.last_7_days || 0 },
        { label: 'Coupons used', value: (s.used || 0) + ' (' + rate + '%)' },
        { label: 'Sales with coupon', value: '$' + this.money(s.revenue) },
        { label: 'Discount given', value: '$' + this.money(s.discount) },
      ];
    },
  },
  methods: {
    fetchLeads(pageUrl) {
      let url = pageUrl || '/api/admin/coupon-leads';
      url += (url.includes('?') ? '&' : '?') + 'limit=25&status=' + this.status;
      if (this.search !== '') url += '&search=' + encodeURIComponent(this.search);
      axios.get(url, this.token).then((res) => {
        this.leads = res.data.data;
        this.stats = res.data.stats;
        this.meta = res.data.meta;
      });
    },
    debouncedFetch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.fetchLeads(), 300);
    },
    extend(lead) {
      axios.post('/api/admin/coupon-leads/' + lead.id + '/extend', { days: 7 }, this.token)
        .then((res) => { this.$toaster.success(res.data.message); this.fetchLeads(); });
    },
    disable(lead) {
      axios.post('/api/admin/coupon-leads/' + lead.id + '/disable', {}, this.token)
        .then((res) => { this.$toaster.success(res.data.message); this.fetchLeads(); });
    },
    exportCsv() {
      // the API needs the bearer token, so a plain link would be refused
      axios.get('/api/admin/coupon-leads/export', Object.assign({ responseType: 'blob' }, this.token))
        .then((res) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(res.data);
          link.download = 'coupon-leads.csv';
          link.click();
          URL.revokeObjectURL(link.href);
        });
    },
    badge(state) {
      return { used: 'badge-success', unused: 'badge-primary', expired: 'badge-secondary' }[state];
    },
    money(v) {
      return Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
  mounted() {
    const token = localStorage.getItem('token');
    this.token = { headers: { Authorization: `Bearer ${token}` } };
    this.fetchLeads();
  },
};
</script>
